import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import Page from 'src/components/Page';
import Spinner from 'src/components/Spinner/Spinner';
import Header from 'src/components/View/Header';
import Results from 'src/views/Settings/MessageView/Results';
import SearchBox from 'src/views/Settings/MessageView/SearchBox';
import ButtonBox from 'src/views/Settings/MessageView/ButtonBox';
import ImportPBTemplatesModal from 'src/views/Settings/MessageView/ModalForms/ImportPBTemplatesModal';
import { MESSAGES } from 'src/constants';
import {
  getMessages,
  setMessageNavigationTab,
  setMessagesQuery,
} from 'src/actions/messagesActions';

import pageViewStyle from 'src/components/View/Page/pageView.style';

function MessageView({
  classes
}) {
  const dispatch = useDispatch();
  const {
    messages,
    loading,
    userMessageCodes,
    query,
  } = useSelector((state) => state.messages);

  useEffect(() => {
    // Set the navigation tab to 'user' by default
    dispatch(setMessageNavigationTab(MESSAGES.MESSAGE_TAB_USER));

    // Initialize query if not present
    if (!query) {
      dispatch(setMessagesQuery({
        search: '',
        contextScope: '',
      }));
    }
    dispatch(getMessages());
  }, [dispatch]);

  const setSearch = (search) => {
    dispatch(setMessagesQuery({
      ...query,
      search,
    }));
  };

  const onSearch = () => {
    dispatch(getMessages());
  };

  // CON-1621 — scope filter; refetch immediately on change (unlike search,
  // which waits for submit).
  const onChangeContextScope = (contextScope) => {
    dispatch(setMessagesQuery({
      ...query,
      contextScope,
    }));
    dispatch(getMessages());
  };

  // Generate the templates found text
  const templatesFoundText = messages?.length === 1
    ? `${messages.length} Template found.`
    : `${messages.length || 0} Templates found.`;

  return (
    <Page
      className={classes.root}
      title="Message Templates"
    >
      <Container maxWidth={false}>
        <Header
          title="Message Templates"
          searchBox={(
            <SearchBox
              loading={loading}
              query={query || { search: '', contextScope: '' }}
              onSearch={onSearch}
              setSearch={setSearch}
              onChangeContextScope={onChangeContextScope}
            />
          )}
          buttonBox={(
            <ButtonBox />
          )}
        />
        <Box mt={3}>
          <Typography
            color="textSecondary"
            variant="body2"
            gutterBottom
          >
            {templatesFoundText}
          </Typography>
        </Box>
        <Box
          className={classes.relativeBox}
        >
          <Spinner
            loading={loading}
            positionType="absolute"
            zIndex="z1300"
          />
          <Results
            messages={messages}
            currentNavigationTab={MESSAGES.MESSAGE_TAB_USER}
            userMessageCodes={userMessageCodes}
          />
        </Box>
      </Container>

      {/* Import PB Templates Modal */}
      <ImportPBTemplatesModal currentTemplateCount={messages?.length || 0} />
    </Page>
  );
}

MessageView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(MessageView, pageViewStyle, { withTheme: true });
